// extracted by mini-css-extract-plugin
export var thumbnailContainer = "styles-module--thumbnailContainer--4xGqX";
export var image = "styles-module--image--IjRVt";
export var playButton = "styles-module--playButton--VUxYS";
export var videoContainer = "styles-module--videoContainer--MTCng";
export var content = "styles-module--content--AUEEB";
export var tagContainer = "styles-module--tagContainer--M1Ojk";
export var tag = "styles-module--tag--98p9G";
export var testimonialItem = "styles-module--testimonialItem--VBbfz";